<!-- Carousel -->
<br />
<div class="container-fluid">
  <!--Carousel Wrapper-->
  <img src="../../../../assets/banner_img/banner.png" class="img-fluid rounded" alt="Responsive image">
  <!--/.Carousel Wrapper-->
  <br />
  <br />
  <br />
  <app-best-product></app-best-product>
</div>
